var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0833 8.4434V13.375H11.1865V8.7441C11.1865 7.60142 10.764 6.81958 9.73804 6.81958C8.95348 6.81958 8.47066 7.36085 8.28961 7.84198C8.22926 8.02241 8.16891 8.26297 8.16891 8.56368V13.375H5.27205C5.27205 13.375 5.3324 5.55661 5.27205 4.77477H8.16891V5.9776C8.53102 5.37618 9.25523 4.5342 10.764 4.5342C12.6349 4.5342 14.0833 5.79717 14.0833 8.4434ZM2.25448 0.625C1.28886 0.625 0.625 1.28656 0.625 2.12854C0.625 2.97052 1.22851 3.63208 2.19413 3.63208C3.2201 3.63208 3.82362 2.97052 3.82362 2.12854C3.88397 1.22642 3.28045 0.625 2.25448 0.625ZM0.806053 13.375H3.70291V4.77477H0.806053V13.375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.993aa776e6d39d278956fbe9fd6c6e16.svg";
export { ForwardRef as ReactComponent };